import { IonButton } from "@ionic/react";
import type { ThemeMode } from "../types";

export function ThemeToggleButton({
  themeMode,
  onToggleTheme
}: {
  themeMode: ThemeMode;
  onToggleTheme: () => void;
}) {
  return (
    <IonButton className="theme-toggle" fill="clear" size="small" onClick={onToggleTheme}>
      Switch to {themeMode === "light" ? "Dark" : "Light"} Mode
    </IonButton>
  );
}
